import { styled } from "@mui/material/styles";

import { TITLE_ICON_GAP, TITLE_ICON_SIZE } from "ui/quick-tip/quick-tip.constants";

import Icons from "assets";

/**
 * Inside `Panel`'s heading, so it takes the heading's type and colour; the glyph follows via `currentColor`.
 * `flex`, not `inline-flex`: an inline box sits on the text baseline, and the glyph, which has none, would
 * push the heading's line box ~3px taller than the title alone.
 */
export const QuickTipTitle = styled("span")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(TITLE_ICON_GAP),
}));

export const QuickTipIcon = styled(Icons.Checkmark)({
  flexShrink: 0,
  width: TITLE_ICON_SIZE,
  height: TITLE_ICON_SIZE,
});
